import React from "react";
import ClientDashboard from "./ClientDashboard";

/**
 * ClientLayoutPreview - A test component to preview the ClientLayout
 * This component bypasses authentication for layout preview purposes
 */
const ClientLayoutPreview = () => {
  return <ClientDashboard />;
};

export default ClientLayoutPreview;
